import ProductsListingSkeleton from '@/components/ProductsListingSkeleton';
import { Skeleton } from '@/components/ui/skeleton';

/** Stable list-route loading shell — matches category/urunler layout to avoid CLS. */
export default function ListPageLoadingShell() {
  return (
    <div className="bg-hzc_beige_200">
      <div className="md:px-4 mt-4 mb-4 flex flex-col">
        <div className="w-full max-w-7xl mx-auto flex flex-col gap-3">
          <div className="px-4 sm:px-0 flex gap-2 items-center">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-4 w-32" />
          </div>
          <Skeleton className="mx-4 sm:mx-0 h-6 w-64 max-w-full" />
          <div className="px-4 sm:px-0 flex flex-col sm:flex-row gap-3 justify-between w-full">
            <Skeleton className="h-10 w-full sm:w-72" />
            <Skeleton className="h-10 w-full sm:w-48" />
          </div>
          <ProductsListingSkeleton />
        </div>
      </div>
    </div>
  );
}
